// src/context/AuthContext.jsx
import {
  createContext,
  useState,
  useEffect,
} from "react";

import api, {
  getAccessToken,
  setAccessToken,
  clearAccessToken,
  refreshAccessToken,
} from "../api";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setTokenState] = useState(
    () => getAccessToken() || ""
  );

  const [userInfo, setUserInfo] = useState(null);
  const [trades, setTrades] = useState([]);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function bootstrapAuth() {
      try {
        let current = getAccessToken();

        if (!current) {
          current = await refreshAccessToken();
        }

        if (!cancelled && current) {
          setTokenState(current);
        }
      } catch {
        // No valid browser/native session.
      } finally {
        if (!cancelled) {
          setAuthReady(true);
        }
      }
    }

    bootstrapAuth();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const { data } = await api.get("/price");

        setCurrentPrice(
          parseFloat(data.btc_usd ?? data.price)
        );
      } catch (err) {
        console.error(
          "Failed to fetch BTC price",
          err
        );
      }
    };

    fetchPrice();
  }, []);

  const saveToken = (token) => {
    setAccessToken(token);
    setTokenState(token || "");
  };

  const logout = () => {
    clearAccessToken();
    setTokenState("");
    setUserInfo(null);
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        userInfo,
        setUserInfo,
        trades,
        setTrades,
        currentPrice,
        saveToken,
        logout,
        authReady,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}